<script>
export default {
  props: {
    fromDateKey: {
      type: String,
      default: 'fromDate',
    },
    untilDateKey: {
      type: String,
      default: 'untilDate',
    },
  },
  data: () => ({
    fromDateMenu: false,
    fromDate: '',
    untilDateMenu: false,
    untilDate: '',
  }),

  watch: {
    fromDate: {
      handler(newValue, oldValue) {
        this.$emit('updateDate', { date: newValue, key: this.fromDateKey })
      },
    },
    untilDate: {
      handler(newValue, oldValue) {
        this.$emit('updateDate', { date: newValue, key: this.untilDateKey })
      },
    },
  },
  methods: {
    clearDate(type) {
      if (type === 'start') {
        this.fromDate = ''
        this.$refs.fromDateMenu.save(this.fromDate)
      } else {
        this.untilDate = ''
        this.$refs.untilDateMenu.save(this.untilDate)
      }
    },
  },
}
</script>

<template lang="">
  <div class="date-picker-wrapper">
    <v-menu
      ref="fromDateMenu"
      v-model="fromDateMenu"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="fromDate"
          label="Start date"
          prepend-inner-icon="mdi-calendar"
          readonly
          hide-details
          class="mt-0 pt-0"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="fromDate" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="fromDateMenu = false"> Cancel </v-btn>
        <v-btn text color="black" @click="clearDate('start')"> Clear </v-btn>
      </v-date-picker>
    </v-menu>
    <div class="pa-4"></div>
    <v-menu
      ref="untilDateMenu"
      v-model="untilDateMenu"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="untilDate"
          label="End date"
          prepend-inner-icon="mdi-calendar"
          readonly
          hide-details
          class="mt-0 pt-0"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="untilDate" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="untilDateMenu = false">
          Cancel
        </v-btn>
        <v-btn text color="black" @click="clearDate('end')"> Clear </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<style scoped>
.date-picker-wrapper {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
}
</style>
